// Anonymous guest id shared across public features (enquiries chat, training RSVP).
export function getGuestId() {
  let id = localStorage.getItem("rc_guest_id");
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `g_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("rc_guest_id", id);
  }
  return id;
}
